import React from "react"

export default function TextWithTeaser ({id, children, limit, labelFull, labelTeaser, remove, danger})
{  
    const target = id || 'id_' + Math.random().toString(36).substr(2, 9)
    const fullLabel = labelFull || '... read more'
    const teaserLabel = labelTeaser || '- view less'
    const maxwords = limit || 75 
  
    const needHandle = () =>
    {
        const words = children.split(' ').length           
        if(words > maxwords) return true
        return false
    }

    const removeElements = () =>
    {
        if(remove)
        {        
            remove.forEach(ele => 
            {            
                switch(ele)
                {
                    case 'p':
                        children = children.replace(/(<p[^>]+?>|<p>|<\/p>)/img, "") 
                        break

                    default: 
                        children = children
                        break
                } 
            }) 
        }
        
        return children
    }
  
    const getTeaser = () =>
    {    
        let text = removeElements()     
        
        if(needHandle()) text = text.split(" ").splice(0,maxwords).join(" ")    

        if(danger)
        {
            return(
                <div className="teaser" dangerouslySetInnerHTML={{__html: text }}></div>
            )
        }

        return (
            <div className="teaser">{text}</div>
        )
    }

    const getText = () =>
    {    
        let text = removeElements()
        if(!text.includes("<p>")){
            text = text.replace(/\n/g,"</br>")
        }
        if(danger)
        {
            return(
                <div className="full" dangerouslySetInnerHTML={{__html: text }}></div>
            )
        }

        return (
            <div className="full">{text}</div>
        )
    }
  
    const show = (e) =>
    {       
        const id = e.target.dataset.target
        const target = document.getElementById(id)
        const show = e.target.dataset.show
        
        target.classList.remove('full','teaser')    
        target.classList.add(show)     
    } 
  
    const status = () =>
    {
        return 'text-teaser'+(needHandle() ? ' teaser' : ' full')
    }   
      
    return (
        <div id={target} className={status()}>
            <div className="text">
                {needHandle() && getTeaser()}                          
                {getText()}
            </div>
            { needHandle() && 
            <div className="handler">
                <div className="full" data-show='full' data-target={target} onClick={show}>{fullLabel}</div>
                <div className="teaser" data-show='teaser' data-target={target} onClick={show}>{teaserLabel}</div>
            </div>}
        </div>
    )
}